import { EHeadingStyleVariant, ETextStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { useIntl } from 'react-intl';

import Renter from '@/assets/become-a-host/rv/renter.png';
import CamperVan from '@/assets/become-a-host/rv/van.png';

import styles from './BecomeAHost.module.css';

export const HostExperiences = () => {
  const intl = useIntl();
  const rvContent = {
    subTitle: intl.formatMessage({
      defaultMessage: 'Built for trust',
      id: 'EmFBXX',
    }),

    title: intl.formatMessage({
      defaultMessage: 'Support in all the right places',
      id: 'pYUz2w',
    }),

    items: [
      {
        title: intl.formatMessage({
          defaultMessage: 'We know who’s renting — you will too',
          id: 'TFUFp6',
        }),
        description: intl.formatMessage({
          defaultMessage:
            'Get booking requests from as close as your own community. And, occasionally, from as far away as across the globe. Leave the background checks to us.',
          id: 'rNrGLG',
        }),
        image: Renter,
        imageAlt: intl.formatMessage({ defaultMessage: 'renter', id: 'MSEqK5' }),
      },

      {
        title: intl.formatMessage({
          defaultMessage: 'Multipoint protection for your RV',
          id: 'qR8b0v',
        }),
        description: intl.formatMessage({
          defaultMessage:
            'Guests purchase a temporary insurance plan that covers your vehicle during their trip — up to $300,000 collision and comprehensive, roadside assistance, windshield coverage, and more. And, we have our own in-house claims team.',
          id: 'tOIGmO',
        }),
        image: CamperVan,
        imageAlt: intl.formatMessage({ defaultMessage: 'camper van', id: 'KMXAAV' }),
      },
    ],
  };

  return (
    <section className={`${styles.spacing} text-center bg-white`}>
      <Text variant={ETextStyleVariant.LegalRegular} className="mb-4 uppercase">
        {rvContent.subTitle}
      </Text>
      <Heading variant={EHeadingStyleVariant.H3} className="mb-12 md:mb-20">
        {rvContent.title}
      </Heading>

      {rvContent.items.map((item, idx) => (
        <div
          className={`flex flex-col-reverse ${
            idx % 2 === 0 ? 'md:flex-row' : 'mt-16 md:mt-24 md:flex-row-reverse'
          } md:items-center gap-8 md:gap-0`}
          key={item.title}>
          <div className="md:flex-1">
            <div className={`text-left ${idx % 2 === 0 ? 'md:mr-16' : 'md:ml-24'} md:max-w-28`}>
              <Heading variant={EHeadingStyleVariant.H4} className="mb-4">
                {item.title}
              </Heading>

              <Text variant={ETextStyleVariant.LargeRegular}>{item.description}</Text>
            </div>
          </div>

          <div className="relative w-full md:flex-1 md:h-80 sm:h-72 h-60">
            <Image
              alt={item.imageAlt}
              src={item.image}
              objectFit="cover"
              className="rounded-2xl"
              layout="fill"
            />
          </div>
        </div>
      ))}
    </section>
  );
};
